import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { post, get } from '@/services/Axios';

import { TokenService } from '@/services/Storage.Service.js';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    status: '',
    token: TokenService.getToken() || '',
    user: TokenService.getUser() || {}
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, data) {
      state.status = 'success';
      state.token = data.token;
      state.user = data.profile;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.user = '';
      state.token = '';
    },
    update_profile(state, data) {
      state.user = data;
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status
  },
  actions: {
    async login({ commit }, request) {
      commit('auth_request');
      try {
        const { data } = await post('/login', { data: request });
        const token = data.token;
        const user = data.profile;
        TokenService.saveToken(token, user);
        commit('auth_success', data);
        return user;
      } catch (e) {
        commit('auth_error');
        TokenService.removeToken();
        throw e;
      }
    },
    async getProfile({ commit }) {
      const params = {
        account_id: this.state.user.accountId
      };
      const { data } = await get('/user/detail', { params });
      commit('update_profile', data);
      TokenService.updateUser(data);
      return data;
    },
    async logout({ commit }) {
      try {
        await get('/logout');
        TokenService.removeToken();
        delete axios.defaults.headers.common.Token;
        commit('logout');
      } catch (e) {
        commit('auth_error');
        throw e;
      }
    },
    async clearSessions({ commit }) {
      TokenService.removeToken();
      delete axios.defaults.headers.common.token;
      commit('logout');
    }
  }
});
